const apiAddress = 'http://localhost:28082/'

const apiOption = {
	method:'POST',
	mode: 'cors',
//	headers: {
//	  'Accept': 'application/json',
//	  'Content-Type': 'application/json'
//	},
}
/*
const apiPostCall = async (command, id, params, callback=null,failure=null) => {
	try {
		const postData = {...apiOption,body:params}
		const response = await fetch(apiAddress + command + '/'+id, postData)
		const json = await response.json()
		if(callback!==null) callback(json)
	} catch(e) {
		console.log(e)
		alert('ローカルコントローラーが起動していません。\nCommand:'+command + '/'+id)
		if(failure!==null) failure()
	}
}
*/

const apiPostCall = async (command, id, formData, progress=null, callback=null, failure=null) => {
	let response = null
	try {
		response = await xhrPromise(apiAddress + command + '/'+id, formData, progress)
		//console.log(response)
		if(callback) callback(response)
	} catch(e) {
		if(failure) failure(e)
	}
	return response
}

const xhrPromise = (url,data,progress=null) => {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest()
		xhr.overrideMimeType("application/json; charset=UTF-8")
		xhr.open('POST', url)
		xhr.upload.addEventListener('progress', (e) => {
			if(progress) {
				progress(e)
			}
		})
		xhr.addEventListener('load', (e) => {
			if (xhr.status === 200) {
				resolve(JSON.parse(xhr.response))
			} else {
				reject(new Error(xhr.statusText))
			}
		})
		xhr.addEventListener('error', (e) => {
			reject(new Error(xhr.statusText))
		})
		xhr.send(data)
	})
}
export default apiPostCall
